import styles from "./tab-container.less";

type TabContainerProps = {
    children: React.ReactNode;
}

export const TabContainer = (props: TabContainerProps) => {
    const { children } = props;

    return <div className={styles.tabContainer}>
        {children}
    </div>

}